(function () {
  'use strict';

  var productJsonCache = {};
  var productVariantCache = {};
  var campaignCartSyncRunning = false;
  var pendingCampaignCart = null;

  function getProductVariant(handle, sku) {
    if (!handle) return Promise.resolve(null);
    var cacheKey = handle + (sku ? '::' + sku : '');
    if (!productJsonCache[handle]) {
      productJsonCache[handle] = fetch('/products/' + handle + '.js', {
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('Offer item could not be loaded.');
        return response.json();
      });
    }
    if (!productVariantCache[cacheKey]) {
      productVariantCache[cacheKey] = productJsonCache[handle].then(function (product) {
        var variants = product.variants || [];
        if (sku) {
          return variants.find(function (variant) { return variant.sku === sku && variant.available; }) || null;
        }
        var available = variants.find(function (variant) { return variant.available; });
        return available || variants[0] || null;
      });
    }
    return productVariantCache[cacheKey];
  }

  function setBusy(form, isBusy) {
    var buttons = form.querySelectorAll('button, input[type="submit"]');
    Array.prototype.forEach.call(buttons, function (button) {
      button.disabled = isBusy;
      button.setAttribute('aria-busy', isBusy ? 'true' : 'false');
    });
  }

  function hideCampaignInternalCartProperties() {
    var propertyNodes = document.querySelectorAll('.ajaxcart__product-meta');
    Array.prototype.forEach.call(propertyNodes, function (node) {
      var label = (node.textContent || '').trim();
      if (label.indexOf('_ol_campaign:') === 0 || label.indexOf('_ol_offer_item:') === 0) node.remove();
    });
  }

  function openOfferCartDrawer() {
    var trigger = document.querySelector('.js-cart-trigger') ||
      document.querySelector('.bid-basket-icon') ||
      document.querySelector('.site-header__cart') ||
      document.querySelector('.header-trigger__link--cart');
    if (!trigger) return;

    if (typeof window.olOpenDrawer === 'function') {
      window.olOpenDrawer();
    } else if (typeof trigger.click === 'function') {
      trigger.click();
    }
  }

  function refreshOfferCartThenOpenDrawer() {
    var cartLoader = window.ajaxCart && typeof window.ajaxCart.load === 'function'
      ? window.ajaxCart.load
      : (window.slate && window.slate.ajaxCart && typeof window.slate.ajaxCart.load === 'function'
        ? window.slate.ajaxCart.load
        : null);

    if (!cartLoader) {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      openOfferCartDrawer();
      return Promise.resolve();
    }

    return new Promise(function (resolve) {
      var finished = false;
      var fallbackTimer;
      var $body = window.jQuery && typeof window.jQuery === 'function'
        ? window.jQuery(document.body)
        : null;

      function finish() {
        if (finished) return;
        finished = true;
        if (fallbackTimer) window.clearTimeout(fallbackTimer);
        openOfferCartDrawer();
        resolve();
      }

      if ($body && typeof $body.one === 'function') {
        $body.one('afterCartLoad.ajaxCart', finish);
      }

      fallbackTimer = window.setTimeout(finish, $body ? 2500 : 350);
      cartLoader();
    });
  }

  function isCartMutationUrl(url) {
    return url && (url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1 || url.indexOf('/cart/clear') !== -1);
  }

  function publishCampaignCart(cart, campaignSync, changedLineKey) {
    if (!cart || !Array.isArray(cart.items)) return;
    document.dispatchEvent(new CustomEvent('ol:cart:changed', {
      detail: {
        cart: cart,
        campaignSync: campaignSync === true,
        changedLineKey: changedLineKey || ''
      }
    }));
  }

  function readCartMutationField(body, fieldName) {
    if (!body) return '';
    if (typeof body.get === 'function') return body.get(fieldName) || '';
    if (typeof body === 'object') return body[fieldName] || '';
    if (typeof body !== 'string') return '';
    try {
      var parsedBody = JSON.parse(body);
      if (parsedBody && parsedBody[fieldName]) return parsedBody[fieldName];
    } catch (error) {
      // Most theme cart requests use URL-encoded form data.
    }
    if (typeof URLSearchParams === 'function') {
      return new URLSearchParams(body).get(fieldName) || '';
    }
    return '';
  }

  function resolveCartLineKey(body) {
    var itemKey = readCartMutationField(body, 'id');
    if (itemKey) return String(itemKey);
    var line = parseInt(readCartMutationField(body, 'line'), 10);
    if (!line) return '';
    var row = document.querySelector('.ajaxcart__row[data-line="' + line + '"]');
    var control = row && row.querySelector('[data-id]');
    return control ? control.getAttribute('data-id') || '' : '';
  }

  function installCampaignCartListener() {
    if (typeof window.fetch === 'function') {
      var originalFetch = window.fetch;
      window.fetch = function () {
        var input = arguments[0];
        var options = arguments[1] || {};
        var requestUrl = typeof input === 'string' ? input : (input && input.url) || '';
        var requestHeaders = options.headers || (input && input.headers);
        var requestBody = options.body || '';
        var changedLineKey = resolveCartLineKey(requestBody);
        var campaignSync = false;
        if (requestHeaders) {
          campaignSync = typeof requestHeaders.get === 'function'
            ? requestHeaders.get('X-OL-Campaign-Sync') === 'true'
            : requestHeaders['X-OL-Campaign-Sync'] === 'true';
        }

        return originalFetch.apply(this, arguments).then(function (response) {
          var responseUrl = response.url || requestUrl;
          if (isCartMutationUrl(responseUrl) && response.ok) {
            response.clone().json().then(function (cart) {
              publishCampaignCart(cart, campaignSync, changedLineKey);
            }).catch(function () {
              // Ignore non-cart or non-JSON responses from unrelated integrations.
            });
          }
          return response;
        });
      };
    }

    if (typeof XMLHttpRequest === 'undefined') return;
    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function () {
      this.addEventListener('load', function () {
        var requestUrl = this.responseURL || this.__olRequestUrl || '';
        if (!isCartMutationUrl(requestUrl) || this.status < 200 || this.status >= 300) return;
        try {
          var cart = this.response;
          if (!cart || !Array.isArray(cart.items)) cart = JSON.parse(this.responseText);
          publishCampaignCart(cart, false, this.__olChangedLineKey || '');
        } catch (error) {
          // Ignore non-cart or non-JSON responses from unrelated integrations.
        }
      });
      this.__olRequestUrl = arguments[1] || '';
      return originalOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      this.__olChangedLineKey = resolveCartLineKey(body);
      return originalSend.apply(this, arguments);
    };
  }

  function addCampaignItems(form, extraHandle, campaignKey, extraSku, bonusHandle, options) {
    options = options || {};
    var productIdInput = form.querySelector('[name="id"]');
    var quantityInput = form.querySelector('[name="quantity"]');
    var productId = productIdInput && productIdInput.value;
    var quantity = parseInt(quantityInput && quantityInput.value, 10) || 1;
    var offerKey = campaignKey || form.getAttribute('data-ol-offer-key') || 'current-offer';

    if (!productId) {
      return Promise.reject(new Error('Choose an available product option first.'));
    }

    var baseProperties = { _ol_campaign: offerKey };
    if (options.baseProperties) {
      Object.keys(options.baseProperties).forEach(function (name) {
        baseProperties[name] = options.baseProperties[name];
      });
    }
    var baseItem = {
      id: Number(productId),
      quantity: quantity,
      properties: baseProperties
    };
    var sellingPlanInput = form.querySelector('[name="selling_plan"]');
    var sellingPlanId = sellingPlanInput && sellingPlanInput.value;
    if (sellingPlanId) {
      var parsedSellingPlanId = Number(sellingPlanId);
      if (!isFinite(parsedSellingPlanId) || parsedSellingPlanId <= 0 || Math.floor(parsedSellingPlanId) !== parsedSellingPlanId) {
        return Promise.reject(new Error('Your subscription choice could not be added. Refresh the page and choose it again.'));
      }
      baseItem.selling_plan = parsedSellingPlanId;
    }
    var items = [baseItem];

    var extraVariantLookup = options.extraVariantId
      ? Promise.resolve({ id: options.extraVariantId })
      : getProductVariant(extraHandle, extraSku);

    return Promise.all([
      extraVariantLookup,
      getProductVariant(bonusHandle, '')
    ]).then(function (variants) {
      var extraVariant = variants[0];
      var bonusVariant = variants[1];
      if ((extraHandle || options.extraVariantId) && (!extraVariant || !extraVariant.id)) {
        throw new Error('The included item is not currently available. Please call us before ordering.');
      }
      if (bonusHandle && (!bonusVariant || !bonusVariant.id)) {
        throw new Error('The included item is not currently available. Please call us before ordering.');
      }
      if (extraVariant && extraVariant.id) {
        var extraProperties = {
          _ol_campaign: offerKey,
          _ol_offer_item: options.extraItemKind || 'Included offer item'
        };
        if (options.extraProperties) {
          Object.keys(options.extraProperties).forEach(function (name) {
            extraProperties[name] = options.extraProperties[name];
          });
        }
        items.push({
          id: Number(extraVariant.id),
          quantity: quantity,
          properties: extraProperties
        });
      }
      if (bonusVariant && bonusVariant.id) {
        items.push({
          id: Number(bonusVariant.id),
          quantity: quantity,
          properties: {
            _ol_campaign: offerKey,
            _ol_offer_item: 'Included offer item: bonus'
          }
        });
      }

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      });
    }).then(function (response) {
      if (!response.ok) {
        return response.json().catch(function () { return {}; }).then(function (body) {
          throw new Error(body.description || body.message || 'The offer could not be added to your basket.');
        });
      }
      return response.json();
    }).then(function () {
      loadKnownCampaignLines();
      if (typeof window.olUpdateCartCount === 'function') {
        window.olUpdateCartCount();
      }
      return refreshOfferCartThenOpenDrawer();
    }).then(function () {
      setBusy(form, false);
    });
  }

  function postCampaignCartChange(key, quantity) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-OL-Campaign-Sync': 'true'
      },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (response) {
      if (!response.ok) throw new Error('The included item could not be synchronised with your basket.');
      return response.json();
    });
  }

  function postCampaignCartUpdate(updates) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-OL-Campaign-Sync': 'true'
      },
      body: JSON.stringify({ updates: updates })
    }).then(function (response) {
      if (!response.ok) throw new Error('Your basket could not be updated. Please try again.');
      return response.json();
    });
  }

  function refreshCampaignCartUI() {
    if (window.ajaxCart && typeof window.ajaxCart.load === 'function') {
      window.ajaxCart.load();
    } else if (window.slate && window.slate.ajaxCart && typeof window.slate.ajaxCart.load === 'function') {
      window.slate.ajaxCart.load();
    } else if (typeof CustomEvent === 'function') {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }
    if (typeof window.olUpdateCartCount === 'function') window.olUpdateCartCount();
  }

  /*
    Locked packages.

    Every line added by a campaign or package carries _ol_campaign. Lines that
    also carry _ol_offer_item are the included items (a free gift, a package heat
    pump or a sauna heater). The main product leads:
    - change or remove the main product: every included item follows it
    - add more of an included item: the main product stays as it is, and the
      extra units go in as a separate line at the normal price
    - lower or remove an included item: it goes back to one per main product,
      with a short note. Removing the main product is how it comes out.

    The last known basket is remembered so a line that has just been removed
    can still be traced back to its package.
  */
  var knownCampaignLines = Object.create(null);

  function rememberCampaignLines(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    var nextLines = Object.create(null);
    cart.items.forEach(function (item) {
      var properties = item.properties || {};
      if (!properties._ol_campaign) return;
      var savedProperties = {};
      Object.keys(properties).forEach(function (name) { savedProperties[name] = properties[name]; });
      nextLines[item.key] = {
        campaign: String(properties._ol_campaign),
        paired: Boolean(properties._ol_offer_item),
        kind: properties._ol_offer_item ? String(properties._ol_offer_item) : '',
        variantId: item.variant_id,
        title: item.product_title || '',
        properties: savedProperties,
        quantity: Number(item.quantity) || 0
      };
    });
    knownCampaignLines = nextLines;
  }

  function loadKnownCampaignLines() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    if (typeof window.fetch !== 'function') return Promise.resolve();
    return window.fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cart) { if (cart) rememberCampaignLines(cart); })
      .catch(function () {
        // The lock still works for lines that are present in the basket.
      });
  }

  /*
    Shopify can give a line a new key when its quantity changes (the key
    includes the line's discounts, so a free gift's key moves with its
    quantity). Find the line by its key first, then by the same variant in the
    same campaign with the same paired role.
  */
  function findCampaignLine(cart, lineKey, known) {
    if (!cart || !Array.isArray(cart.items) || !lineKey) return null;
    var i;
    for (i = 0; i < cart.items.length; i++) {
      if (cart.items[i].key === lineKey) return cart.items[i];
    }
    var variantId = String(lineKey).split(':')[0];
    var campaign = known && known.campaign;
    if (!variantId || !campaign) return null;
    for (i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var properties = item.properties || {};
      if (String(item.variant_id) === variantId &&
          String(properties._ol_campaign || '') === campaign &&
          Boolean(properties._ol_offer_item) === Boolean(known.paired)) {
        return item;
      }
    }
    return null;
  }

  function postCampaignCartAdd(items) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-OL-Campaign-Sync': 'true'
      },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      if (!response.ok) throw new Error('The included item could not be synchronised with your basket.');
      return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
    }).then(function (response) {
      return response.json();
    });
  }

  function shortTitle(title) {
    return String(title || '').replace(/^Outdoor Living\s+/i, '').replace(/\s+-\s+.*$/, '').trim();
  }

  function reconcileCampaignCart(cart, changedLineKey) {
    if (!cart || !Array.isArray(cart.items)) return Promise.resolve();

    var previousLines = knownCampaignLines;
    var changedLineKeys = (Array.isArray(changedLineKey) ? changedLineKey : [changedLineKey]).filter(Boolean);
    var groups = Object.create(null);

    function groupFor(key) {
      if (!groups[key]) {
        groups[key] = { mainQuantity: 0, mainTitle: '', kinds: Object.create(null), changedKinds: Object.create(null) };
      }
      return groups[key];
    }

    function kindFor(group, kind) {
      if (!group.kinds[kind]) group.kinds[kind] = { total: 0, previousTotal: 0, variantId: null, title: '', properties: null };
      return group.kinds[kind];
    }

    // What the package looked like before this change.
    Object.keys(previousLines).forEach(function (lineKey) {
      var known = previousLines[lineKey];
      var group = groupFor(known.campaign);
      if (!known.paired) {
        if (!group.mainTitle) group.mainTitle = known.title;
        return;
      }
      var kindInfo = kindFor(group, known.kind);
      kindInfo.previousTotal += known.quantity;
      kindInfo.variantId = kindInfo.variantId || known.variantId;
      kindInfo.title = kindInfo.title || known.title;
      kindInfo.properties = kindInfo.properties || known.properties;
    });

    // What it looks like now.
    cart.items.forEach(function (item) {
      var properties = item.properties || {};
      var key = properties._ol_campaign;
      if (!key) return;
      var group = groupFor(key);
      if (properties._ol_offer_item) {
        // One offer can include more than one item (for example a heat pump and an IcePOD).
        var kindInfo = kindFor(group, String(properties._ol_offer_item));
        kindInfo.total += Number(item.quantity) || 0;
        kindInfo.variantId = item.variant_id;
        kindInfo.title = item.product_title || kindInfo.title;
        kindInfo.properties = properties;
      } else {
        group.mainQuantity += Number(item.quantity) || 0;
        group.mainTitle = item.product_title || group.mainTitle;
      }
    });

    // Which included items did the customer change themselves?
    changedLineKeys.forEach(function (lineKey) {
      var known = previousLines[lineKey];
      var currentItem = findCampaignLine(cart, lineKey, known);
      var currentProperties = currentItem ? currentItem.properties || {} : {};
      var campaign = currentProperties._ol_campaign || (known && known.campaign);
      if (!campaign) return;
      var paired = currentItem ? Boolean(currentProperties._ol_offer_item) : Boolean(known && known.paired);
      if (!paired) return;
      var kind = currentItem ? String(currentProperties._ol_offer_item) : (known && known.kind) || '';
      if (kind) groupFor(campaign).changedKinds[kind] = true;
    });

    // Extra units the customer asked for go in at the normal price, and notes
    // explain anything we had to put back.
    var extraItems = [];
    var notes = [];
    Object.keys(groups).forEach(function (campaign) {
      var group = groups[campaign];
      Object.keys(group.kinds).forEach(function (kind) {
        var kindInfo = group.kinds[kind];
        if (!group.changedKinds[kind] || !group.mainQuantity) return;
        if (kindInfo.total > group.mainQuantity && kindInfo.variantId) {
          var extra = kindInfo.total - group.mainQuantity;
          extraItems.push({ id: kindInfo.variantId, quantity: extra });
          notes.push(extra === 1
            ? 'We’ve added the extra ' + shortTitle(kindInfo.title) + ' at the normal price.'
            : 'We’ve added ' + extra + ' × ' + shortTitle(kindInfo.title) + ' at the normal price.');
        } else if (kindInfo.total < group.mainQuantity) {
          notes.push('The ' + shortTitle(kindInfo.title) + ' comes with your ' + shortTitle(group.mainTitle) + ', so it stays in your basket. Remove the ' + shortTitle(group.mainTitle) + ' to take it out.');
        }
      });
    });

    // Find the next change needed so every included item matches the main product.
    // Shopify can split or re-key lines after every change (a discount may only
    // cover one unit), so this is worked out again from the latest basket each time.
    function nextChange(currentCart) {
      var current = Object.create(null);
      currentCart.items.forEach(function (item) {
        var properties = item.properties || {};
        var campaign = properties._ol_campaign;
        if (!campaign || !groups[campaign]) return;
        if (!current[campaign]) current[campaign] = { main: 0, kinds: Object.create(null) };
        if (properties._ol_offer_item) {
          var kind = String(properties._ol_offer_item);
          if (!current[campaign].kinds[kind]) current[campaign].kinds[kind] = [];
          current[campaign].kinds[kind].push(item);
        } else {
          current[campaign].main += Number(item.quantity) || 0;
        }
      });

      var campaigns = Object.keys(groups);
      for (var c = 0; c < campaigns.length; c++) {
        var campaign = campaigns[c];
        var state = current[campaign] || { main: 0, kinds: Object.create(null) };
        var desired = state.main;
        var kindNames = Object.keys(groups[campaign].kinds);
        for (var k = 0; k < kindNames.length; k++) {
          var kind = kindNames[k];
          var lines = state.kinds[kind] || [];
          var total = lines.reduce(function (sum, line) { return sum + (Number(line.quantity) || 0); }, 0);
          if (total === desired) continue;
          if (total < desired) {
            if (lines.length) {
              return { type: 'change', key: lines[0].key, quantity: (Number(lines[0].quantity) || 0) + (desired - total) };
            }
            var kindInfo = groups[campaign].kinds[kind];
            if (!kindInfo.variantId || !kindInfo.properties) continue;
            return { type: 'add', items: [{ id: kindInfo.variantId, quantity: desired, properties: kindInfo.properties }] };
          }
          // Too many: take units off the last line first (normally the undiscounted one).
          var last = lines[lines.length - 1];
          var lastQuantity = Number(last.quantity) || 0;
          return { type: 'change', key: last.key, quantity: Math.max(0, lastQuantity - (total - desired)) };
        }
      }
      return null;
    }

    var latestCart = cart;
    var changeCount = 0;
    function applyNext() {
      var change = changeCount < 12 ? nextChange(latestCart) : null;
      if (!change) return Promise.resolve();
      changeCount += 1;
      var request = change.type === 'add'
        ? postCampaignCartAdd(change.items)
        : postCampaignCartChange(change.key, change.quantity);
      return request.then(function (updatedCart) {
        latestCart = updatedCart && Array.isArray(updatedCart.items) ? updatedCart : latestCart;
        return applyNext();
      });
    }

    return applyNext().then(function () {
      if (!extraItems.length) return null;
      changeCount += 1;
      return postCampaignCartAdd(extraItems).then(function (updatedCart) {
        latestCart = updatedCart && Array.isArray(updatedCart.items) ? updatedCart : latestCart;
      });
    }).then(function () {
      rememberCampaignLines(latestCart);
      if (changeCount) refreshCampaignCartUI();
      if (notes.length) showCampaignCartNote(notes.join(' '));
    });
  }

  /*
    A short note in the corner when the basket has done something the customer
    didn't directly ask for. It survives the basket page reloading.
  */
  var campaignNoteTimer = null;

  function showCampaignCartNote(message, fromReload) {
    if (!message || !document.body) return;
    if (!fromReload) {
      try { window.sessionStorage.setItem('olCartNote', message); } catch (error) { /* storage can be blocked */ }
    }
    var note = document.getElementById('ol-cart-note');
    if (!note) {
      note = document.createElement('div');
      note.id = 'ol-cart-note';
      note.className = 'ol-cart-note';
      note.setAttribute('role', 'status');
      note.setAttribute('aria-live', 'polite');
      document.body.appendChild(note);
    }
    note.textContent = message;
    note.classList.add('ol-cart-note--visible');
    if (campaignNoteTimer) clearTimeout(campaignNoteTimer);
    campaignNoteTimer = setTimeout(function () {
      note.classList.remove('ol-cart-note--visible');
      try { window.sessionStorage.removeItem('olCartNote'); } catch (error) { /* ignore */ }
    }, 6500);
  }

  function showSavedCampaignCartNote() {
    var message = null;
    try { message = window.sessionStorage.getItem('olCartNote'); } catch (error) { message = null; }
    if (message) showCampaignCartNote(message, true);
  }

  /*
    While a package is being brought back in step, the basket buttons are held
    so a second click can't act on lines that are about to move.
  */
  var campaignBusyTimer = null;

  function cartHasCampaignLines(cart) {
    if (!cart || !Array.isArray(cart.items)) return false;
    for (var i = 0; i < cart.items.length; i++) {
      if ((cart.items[i].properties || {})._ol_campaign) return true;
    }
    return Object.keys(knownCampaignLines).length > 0;
  }

  function setCampaignBusy(isBusy) {
    var root = document.documentElement;
    if (!root) return;
    if (campaignBusyTimer) {
      clearTimeout(campaignBusyTimer);
      campaignBusyTimer = null;
    }
    if (isBusy) {
      root.classList.add('ol-cart-syncing');
      root.setAttribute('aria-busy', 'true');
      return;
    }
    // Give the basket a moment to redraw with the final quantities.
    campaignBusyTimer = setTimeout(function () {
      root.classList.remove('ol-cart-syncing');
      root.removeAttribute('aria-busy');
      campaignBusyTimer = null;
    }, 700);
  }

  function blockClicksWhileSyncing(event) {
    var root = document.documentElement;
    if (!root || !root.classList.contains('ol-cart-syncing')) return;
    var target = event.target && event.target.closest
      ? event.target.closest('.ajaxcart__qty-adjust, .ajaxcart__remove, [data-ol-cart-remove], .cart-form button[name="update"], .cart-form .js-qty__adjust')
      : null;
    if (!target) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  function handleCampaignCartChanged(event) {
    var detail = event.detail || {};
    if (detail.campaignSync || !detail.cart) return;
    if (!cartHasCampaignLines(detail.cart)) return;
    pendingCampaignCart = { cart: detail.cart, changedLineKey: detail.changedLineKey || '' };
    setCampaignBusy(true);
    if (campaignCartSyncRunning) return;

    campaignCartSyncRunning = true;
    function drainCampaignCartQueue() {
      var pending = pendingCampaignCart;
      pendingCampaignCart = null;
      if (!pending) {
        campaignCartSyncRunning = false;
        setCampaignBusy(false);
        return;
      }
      reconcileCampaignCart(pending.cart, pending.changedLineKey).catch(function (error) {
        console.error('Campaign basket sync error:', error);
        // Show the basket as it really is rather than a half-finished change.
        refreshCampaignCartUI();
        return loadKnownCampaignLines();
      }).then(drainCampaignCartQueue);
    }
    drainCampaignCartQueue();
  }

  function handleCartPageUpdate(event) {
    var form = event.target && event.target.closest ? event.target.closest('form.cart-form') : null;
    if (!form) return;
    var submitter = event.submitter || document.activeElement;
    if (submitter && submitter.name === 'checkout') return;
    var isUpdateButton = !event.submitter || (submitter && (submitter.name === 'update' || (submitter.classList && submitter.classList.contains('update-cart'))));
    if (!isUpdateButton) return;

    var updates = {};
    var changedQualifyingKeys = [];
    var quantityInputs = form.querySelectorAll('input[name="updates[]"]');
    Array.prototype.forEach.call(quantityInputs, function (input) {
      var row = input.closest('[data-ol-line-key]');
      var lineKey = input.getAttribute('data-id') || (row && row.getAttribute('data-ol-line-key'));
      if (!lineKey) return;
      var quantity = Math.max(0, parseInt(input.value, 10) || 0);
      updates[lineKey] = quantity;
      if (row && row.getAttribute('data-ol-campaign-key') && quantity !== Number(row.getAttribute('data-ol-current-quantity'))) {
        changedQualifyingKeys.push(lineKey);
      }
    });
    if (!Object.keys(updates).length) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    var busyButton = submitter && typeof submitter.setAttribute === 'function' ? submitter : form.querySelector('button[name="update"]');
    if (busyButton) {
      busyButton.disabled = true;
      busyButton.setAttribute('aria-busy', 'true');
    }
    postCampaignCartUpdate(updates).then(function (cart) {
      return reconcileCampaignCart(cart, changedQualifyingKeys);
    }).then(function () {
      window.location.reload();
    }).catch(function (error) {
      if (busyButton) {
        busyButton.disabled = false;
        busyButton.removeAttribute('aria-busy');
      }
      window.alert(error.message);
    });
  }

  function handleCartPageRemove(event) {
    var link = event.target && event.target.closest ? event.target.closest('[data-ol-cart-remove]') : null;
    if (!link) return;
    var lineKey = link.getAttribute('data-ol-cart-remove');
    if (!lineKey) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    link.setAttribute('aria-disabled', 'true');
    postCampaignCartChange(lineKey, 0).then(function (cart) {
      return reconcileCampaignCart(cart, [lineKey]);
    }).then(function () {
      window.location.reload();
    }).catch(function (error) {
      link.removeAttribute('aria-disabled');
      window.alert(error.message);
    });
  }

  function handleCampaignSubmit(event) {
    var form = event.target && event.target.closest ? event.target.closest('form[data-ol-campaign-form="true"]') : null;
    if (!form) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    setBusy(form, true);

    var extraHandle = form.getAttribute('data-ol-gift-handle') || '';
    var extraSku = form.getAttribute('data-ol-gift-sku') || '';
    var bonusHandle = form.getAttribute('data-ol-bonus-handle') || '';
    var campaignKey = '';

    if (form.getAttribute('data-ol-package-type') === 'sauna') {
      var saunaVariantInput = form.querySelector('[name="id"]');
      var saunaVariantId = saunaVariantInput && saunaVariantInput.value;
      var heaterVariantId = form.getAttribute('data-ol-gift-variant-id') || '';
      var heaterTitle = form.getAttribute('data-ol-gift-title') || 'Sauna heater';
      if (!heaterVariantId) {
        setBusy(form, false);
        window.alert('Choose a heater for your sauna first.');
        return;
      }
      var saunaTitleNode = document.querySelector('.product-single__title-text');
      var saunaTitle = saunaTitleNode ? saunaTitleNode.textContent.trim() : 'your sauna';
      var saunaOptionNode = saunaVariantInput && saunaVariantInput.options && saunaVariantInput.options[saunaVariantInput.selectedIndex];
      var saunaOption = saunaOptionNode ? saunaOptionNode.textContent.trim() : '';
      if (saunaOption && saunaOption.indexOf('Default') !== 0) saunaTitle += ' (' + saunaOption + ')';

      addCampaignItems(form, '', 'sauna:' + saunaVariantId + ':' + heaterVariantId, '', '', {
        extraVariantId: heaterVariantId,
        extraItemKind: 'Sauna heater',
        baseProperties: { Heater: heaterTitle },
        extraProperties: { 'Fitted to': saunaTitle }
      }).catch(function (error) {
        setBusy(form, false);
        window.alert(error.message);
      });
      return;
    }
    if (form.getAttribute('data-ol-offer-key') === 'active-13ft-package') {
      var selectedPackage = form.getAttribute('data-ol-selected-package') || 'base';
      campaignKey = selectedPackage === 'bundle' ? 'active-13ft-package' : 'active-13ft-base';
      extraHandle = selectedPackage === 'bundle' ? (form.getAttribute('data-ol-addon-handle') || '') : '';
      extraSku = '';
    }

    addCampaignItems(form, extraHandle, campaignKey, extraSku, bonusHandle).catch(function (error) {
      setBusy(form, false);
      window.alert(error.message);
    });
  }

  function handlePackageChoice(event) {
    var button = event.target.closest ? event.target.closest('[data-ol-package-choice]') : null;
    if (!button) return;
    var selector = button.closest('[data-ol-package-selector]');
    var form = selector ? selector.closest('form[data-ol-campaign-form="true"]') : null;
    if (!form) {
      form = document.querySelector('form[data-ol-campaign-form="true"]');
    }
    if (!form) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var selectedPackage = button.getAttribute('data-ol-package-choice') || 'base';
    var choices = selector ? selector.querySelectorAll('[data-ol-package-choice]') : document.querySelectorAll('[data-ol-package-choice]');
    Array.prototype.forEach.call(choices, function (choice) {
      var isSelected = choice === button;
      choice.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      choice.classList.toggle('ol-offer-package__choice--selected', isSelected);
    });
    form.setAttribute('data-ol-selected-package', selectedPackage);
  }

  function handleOfferAnchorClick(event) {
    var anchor = event.target.closest ? event.target.closest('[data-ol-offer-anchor]') : null;
    if (!anchor) return;

    var href = anchor.getAttribute('href') || '';
    if (href.indexOf('#ol-offer-pdp-card-') !== 0) return;

    var target = document.getElementById(href.slice(1));
    if (!target) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    var stickyHeader = document.querySelector('.sticky-header') || document.querySelector('.js-header.js-header-sticky') || document.querySelector('[data-sticky-header], .site-header, .header');
    var headerOffset = stickyHeader ? stickyHeader.getBoundingClientRect().height + 18 : 120;
    var targetTop = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (window.jQuery && typeof window.jQuery === 'function') {
      window.jQuery('html, body').stop(true).animate({ scrollTop: Math.max(0, targetTop) }, reducedMotion ? 0 : 800);
    } else {
      window.scrollTo({ top: Math.max(0, targetTop), behavior: reducedMotion ? 'auto' : 'smooth' });
    }
    if (typeof target.focus === 'function') {
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    }
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', href);
    }
  }

  document.addEventListener('submit', handleCampaignSubmit, true);
  document.addEventListener('submit', handleCartPageUpdate, true);
  document.addEventListener('click', handlePackageChoice, true);
  document.addEventListener('click', handleOfferAnchorClick, true);
  document.addEventListener('click', blockClicksWhileSyncing, true);
  document.addEventListener('click', handleCartPageRemove, true);
  document.addEventListener('ol:cart:changed', handleCampaignCartChanged);
  installCampaignCartListener();
  loadKnownCampaignLines();
  window.olCampaignCart = { refresh: loadKnownCampaignLines };
  showSavedCampaignCartNote();
  if (window.jQuery && typeof window.jQuery === 'function') {
    window.jQuery(document.body).on('afterCartLoad.ajaxCart', hideCampaignInternalCartProperties);
  }
}());
